<template>
    <div>
        <el-menu
            mode="horizontal"
            class="topmenu"
            :default-active="activeIndex"
            @select="handleselect"
        >
            <el-menu-item index="1">热门文章</el-menu-item>
        </el-menu>
        <div class="sort">
            <p>共{{total}}篇文章</p>
            <!-- <div class="flex-x">
        <p class="sortright">默认</p>
        <i class="el-icon-arrow-down"></i>
        <div class="line"></div>
        <i class="el-icon-sort"></i>
            </div>-->
        </div>
        <div class="essaycontent">
            <div v-for="single in essaylist" :key="single.id" v-show="essaylist.length > 0">
                <single-article :single="single" ></single-article>
            </div>
            <el-pagination
                background
                layout="jumper, prev, pager, next, slot, total"
                :total="total"
                :current-page="page"
                @current-change="currentChange"
                @prev-click="prevClick"
                @next-click="nextClick"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    import SingleArticle from './common/SingleArticle';
    export default {
        components: {
            SingleArticle
        },
        data() {
            return {
                activeIndex: '1',
                essaytitle: '',
                essaylist: [],
                total: 0,
                page: 1
            };
        },
        mounted() {
            this.getessaylist();
        },
        methods: {
            handleselect(val) {
                this.activeIndex = val;
                this.essaylist = [];
                if (val == 1) {
                    this.getessaylist();
                }
            },
            getessaylist() {
                this.httpGet(this.$root.getExpertArticle, {
                    professor: this.$route.query.professor,
                    type: 1,
                    page: this.page,
                    size: 10
                })
                    .then(result => {
                        if (result.count) {
                            this.essaylist.push(...result.list);
                            this.total = Number(result.count);
                        } else {
                            this.essaylist = [];
                            this.total = 0;
                        }
                        console.log(result.data, 88);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            gotoquery(e) {
                this.$router.push({
                    name: 'article-details',
                    query: {
                        id: e
                    }
                });
            },
            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.essaylist = [];
                if (this.activeIndex == 1) {
                    this.getessaylist();
                } else {
                    this.getradiolist();
                }
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.essaylist = [];
                if (this.activeIndex == 1) {
                    this.getessaylist();
                } else {
                    this.getradiolist();
                }
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.essaylist = [];
                if (this.activeIndex == 1) {
                    this.getessaylist();
                } else {
                    this.getradiolist();
                }
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    * {
        box-sizing: border-box;
    }

    .flex-x {
        flex-x();
    }

    .single-article {
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 20px;
        width: 100% !important;
        max-width: 900px !important;
    }

    .topmenu {
        width: 100%;
        height: 64px;
        border-radius: 8px;
        padding-right: 0px !important;
    }

    .sort {
        margin-top: 24px;
        width: 100%;
        flex-x();
        font-size: 14px;
        opacity: 0.65;

        p {
            flex-shrink: 0;
        }

        .sortright {
        }

        .el-icon-arrow-down {
            margin-right: 26px;
            margin-left: 4px;
        }
    }

    .essaycontent {
        margin-top: 24px;
        width: 100%;

        .essay {
            border-radius: 8px;
            background-color: white;
            display: flex;
            flex-direction: row;

            .essayleft {
                display: flex;
                flex-direction: column;

                .essaytitle {
                    cursor: pointer;
                    font-size: 18px;
                    opacity: 0.85;
                    margin-top: 24px;
                    margin-left: 24px;
                }

                .essaydes {
                    cursor: pointer;
                    width: 644px;
                    margin-top: 8px;
                    margin-left: 24px;
                    font-size: 14px;
                }

                .essaybottom {
                    margin-top: 12px;
                    margin-left: 24px;
                    display: flex;
                    flex-direction: row;
                    align-content: center;

                    .essaymoney {
                        font-size: 12px;
                        color: #9298A6;
                        margin-left: 3px;
                    }

                    .essayuser {
                        font-size: 12px;
                        color: #9298A6;
                        margin-left: 16px;
                    }

                    .el-icon-s-comment {
                        width: 12px;
                        height: 12px;
                        margin-left: 16px;
                        color: #9DA4B3;
                    }

                    .comment {
                        margin-left: 3px;
                        font-size: 12px;
                        color: #9298A6;
                    }

                    .el-icon-star-on {
                        width: 11.5px;
                        height: 11px;
                        margin-left: 16px;
                        color: #9DA4B3;
                    }

                    .collection {
                        font-size: 12px;
                        color: #9DA4B3;
                        margin-left: 3px;
                    }

                    .el-icon-s-promotion {
                        width: 11.4px;
                        height: 11.4px;
                        color: #9DA4B3;
                        margin-left: 16px;
                    }

                    .share {
                        font-size: 12px;
                        color: #9DA4B3;
                        margin-left: 3px;
                    }
                }
            }

            .essayimg {
                cursor: pointer;
                margin-top: 43px;
                margin-left: 32px;
                margin-right: 24px;
                width: 156px;
                height: 104px;
            }
        }
    }

    >>>.el-pagination {
        // width: 840px;
        flex-center();
        padding: 20px;
        background: white;
    }
</style>
